import Loader from "modules/Loader";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function FromMedTable({
  engagementCallData,
  isLoading,
  assignmentSumData,
  setSummaryData,
}) {
  const [allFlag, setAllFlag] = useState(false);
  const [engagementData, setEngagementData] = useState([]);

  useEffect(() => {
    setEngagementData(engagementCallData);
  }, [engagementCallData]);

  useEffect(() => {
    const selectedData = engagementData
      ?.filter((engagement) => {
        return engagement?.checked;
      })
      ?.map((engagement) => {
        return { type: engagement?.type, value: engagement?.value };
      });
    setSummaryData((curr) => {
      curr["transferData"] = selectedData;
      return { ...curr };
    });
  }, [engagementData]);

  const handleChange = (event, engagementId) => {
    if (event.target.checked) {
      setEngagementData((prevData) =>
        prevData?.map((engagement) =>
          engagement?.key === engagementId
            ? { ...engagement, checked: true }
            : engagement
        )
      );
    } else {
      setEngagementData((prevData) =>
        prevData?.map((engagement) =>
          engagement.key === engagementId
            ? { ...engagement, checked: false }
            : engagement
        )
      );
    }
  };

  const handleAllChange = (event) => {
    if (event.target.checked) {
      setEngagementData((prevData) =>
        prevData?.map((engagement) => ({ ...engagement, checked: true }))
      );
      setAllFlag(true);
    } else {
      setEngagementData((prevData) =>
        prevData?.map((engagement) => ({ ...engagement, checked: false }))
      );
      setAllFlag(false);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between gap-2">
        <div className="d-flex">
          <div>Total Patients :</div>
          <div>{assignmentSumData?.cases}</div>
        </div>
        <div className="d-flex">
          <div>Active Patients :</div>
          <div>{assignmentSumData?.active_cases}</div>
        </div>
        <div className="d-flex">
          <div>Open Orders:</div>
          <div>{assignmentSumData?.open_orders}</div>
        </div>
      </div>
      <div>
        <table
          className="d-flex flex-column mt-3  rounded table-hover scrollable-container"
          style={{
            minHeight: "10vh",
            maxHeight: "25vh",
            overflowY: "scroll",
          }}
        >
          <thead className="d-flex text-gray border-black border rounded-top table-head position-sticky top-0">
            <th className="flex-1 fw-bold text-secondary  ps-2 border-end py-2 mt-1">
              <div className="form-check" style={{ marginLeft: "0.4rem" }}>
                <OverlayTrigger
                  overlay={
                    <Tooltip
                      style={{ position: "fixed" }}
                      id="overlay-trigger-example"
                    >
                      <div className="fw-bold">Select All</div>
                    </Tooltip>
                  }
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckIndeterminate"
                    onChange={handleAllChange}
                    checked={allFlag ? true : false}
                    style={{ content: "-" }}
                  />
                </OverlayTrigger>
                <label
                  className="form-check-label fw-bold text-black"
                  htmlFor="flexCheckIndeterminate"
                >
                  Engagement
                </label>
              </div>
            </th>
            <th className="flex-1 fw-bold text- ps-2 border-end text-black mt-1 py-1">
              Count
            </th>
          </thead>
          <div>
            {isLoading ? (
              <div className="position-absolute mt-5 start-50 translate-middle">
                <Loader />
              </div>
            ) : engagementData ? (
              engagementData?.map((engagement, engIndex) => {
                return (
                  <tr
                    id="table-row-value"
                    key={engagement?.key}
                    className={
                      engagement.checked
                        ? `flex-1 border border-top-0 table-row  ${
                            engIndex === engagementData?.length - 1 &&
                            `rounded-bottom`
                          } d-flex justify-content-between selected-table-row`
                        : `flex-1 border border-top-0  table-row ${
                            engIndex === engagementData?.length - 1 &&
                            `rounded-bottom`
                          } d-flex justify-content-between`
                    }
                    style={{
                      backgroundColor: engagement.checked ? "#D5E5FA" : null,
                    }}
                  >
                    <td className="flex-1  p-1 text-left  border-end text-break">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={engagement?.key}
                          id={`flexCheckIndeterminate-${engagement?.key}`}
                          onClick={(event) =>
                            handleChange(event, engagement?.key)
                          }
                          checked={engagement?.checked}
                        />

                        <label
                          className="form-check-label fw-bold"
                          htmlFor={`flexCheckIndeterminate-${engagement?.key}`}
                        >
                          <span className="text-black">
                            {engagement?.title}
                          </span>
                        </label>
                      </div>
                    </td>
                    <td className="flex-1  p-1 text-left  border-end text-break">
                      {engagement?.count}
                    </td>
                  </tr>
                );
              })
            ) : (
              <h3 className="text-center border p-3 rounded-bottom bg-white text-black">
                Data not found <NoData />
              </h3>
            )}
          </div>
        </table>
      </div>
    </div>
  );
}

export default FromMedTable;
